import { render, staticRenderFns } from "./wStackedContentBanner.vue?vue&type=template&id=452e16c8&scoped=true"
import script from "./wStackedContentBanner.vue?vue&type=script&lang=js"
export * from "./wStackedContentBanner.vue?vue&type=script&lang=js"
import style0 from "./wStackedContentBanner.vue?vue&type=style&index=0&id=452e16c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e16c8",
  null
  
)

export default component.exports